<template>
  <div
    ref="form"
    :class="{ 'is-hover': isHover }"
    @drag.prevent.stop
    @dragstart.prevent.stop
    @dragover.prevent.stop="onEnter"
    @dragenter.prevent.stop="onEnter"
    @dragend.prevent.stop="onLeave"
    @dragleave.prevent.stop="onLeave"
    @drop.prevent.stop="onDrop"
  >
    <slot name="top" />
    <div class="media-zone" :class="[zoneClass, { 'is-hover': isHover }]">
      <input
        v-if="!disabled"
        ref="file"
        type="file"
        :accept="accept"
        :multiple="multiple"
        @change="onFileChange"
      />
      <slot />
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
export default {
  name: 'DropZone',
  props: {
    multiple: { type: Boolean, default: false },
    accept: { type: String, default: 'image/*' },
    disabled: { type: Boolean, default: false },
    zoneClass: { type: String, default: '' }
  },
  data() {
    return {
      isHover: false
    }
  },
  methods: {
    onEnter() {
      if (!this.disabled) this.isHover = true
    },
    onLeave() {
      this.isHover = false
    },
    onDrop(event) {
      if (this.disabled) return
      this.onLeave()
      this.checkFiles(event.dataTransfer.files, 'drop')
    },
    onFileChange(event) {
      this.checkFiles(event.target.files)
      event.target.value = ''
    },
    checkFiles(files, eventType = 'input') {
      if (!files.length) return
      files = this.multiple ? files : [files[0]]
      Array.prototype.forEach.call(files, file => {
          this.$emit('change', file)
      })
    },
  }
}
</script>

<style lang="scss">
.media-zone {
  position: relative;
  border: dashed 1px #ced4da;
  background-color: white;
  color: #adb5bd;
  text-align: center;
  border-radius: 5px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  &.is-hover {
    border-color: #18d6b5;
    color: #18d6b5;
  }
  input[type='file'] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    font-size: 100px;
    opacity: 0;
    color: transparent;
    z-index: 2;
    cursor: pointer;
    overflow: hidden;
  }
}
</style>
